export const ListWithInlineDescription = ({label, action, value}) => {
    return (
        <div className="relative flex items-start">
          <div className="flex h-6 items-center">
            <input
              id={label}
              aria-describedby="comments-description"
              name={label}
              type="checkbox"
              checked={value}
              onClick={() => action()}
              className="h-[32px] w-[32px] rounded border-gray-300 border-solid text-green-600"
            />
          </div>
          <div className="ml-3 text-sm leading-6">
            <label htmlFor={label} className="font-medium text-gray-900">
              {label}
            </label>
          </div>
        </div>
    )
}

export const ListWithInlineDescriptionRed = ({label, action, value}) => {
    return (
        <div className="relative flex items-start">
          <div className="flex h-6 items-center">
            <input
              id={label}
              aria-describedby="comments-description"
              name={label}
              type="checkbox"
              checked={value}
              onClick={() => action()}
              className="h-[32px] w-[32px] rounded border-grey-600 border-solid text-red-300 ring-transparent"
            />
          </div>
          <div className="ml-3 text-sm leading-6">
            <label htmlFor={label} className="font-medium text-gray-600">
              {label}
            </label>
          </div>
        </div>
    )
}